import React, { useEffect, useRef, useState, useContext } from 'react'
import useOnScreen from '../hooks/useOnScreen'
import { ContextLoader } from '../context'
import SplitText from './SplitText'

const alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

const GlitchingChars = ({
	children,
	delay = 100,
	onScreenTrigger = true,
	isMouseOver = null
}) => {

	const [isLoading] = useContext(ContextLoader);

	const containerEl = useRef(null);
	const charsContainerEl = useRef(null);
	const charsEl = useRef(null);
	let intervalsId = [];
	let timeoutsId = [];

	const onScreen = useOnScreen(containerEl);
	const [isAnimStarted, updateIsAnimStarted] = useState(false);

	useEffect(() => {
		if ((onScreenTrigger === true && onScreen === true && isLoading === false) ||
				(onScreenTrigger === false && isLoading === false)) {
			setTimeout(() => {
				startAnim();
			}, delay);
		};
	}, [onScreen, isLoading]);

	const startAnim = () => {
		updateIsAnimStarted(true);
		if (charsContainerEl.current === null) return;
		charsEl.current = [...charsContainerEl.current.querySelectorAll('.char')];
		charsEl.current.map((char, index) => {
			const duration = Math.random() * 0.75
			char.style.transition = `opacity ${duration}s linear`;
			char.style.animationDuration = `${duration}s`;

			if (intervalsId[index]) window.clearRequestInterval(intervalsId[index]);
			intervalsId[index] = window.requestInterval(() => {
				char.innerHTML = alphabet[Math.floor(Math.random() * alphabet.length)];
			}, 100);

			clearTimeout(timeoutsId[index]);
			timeoutsId[index] = setTimeout(() => {
				if (intervalsId[index]) window.clearRequestInterval(intervalsId[index]);
				char.innerHTML = char.getAttribute('data-char');
				char.style.transition = ``;
			}, duration * 1000);
		})
	}

	useEffect(() => {
		if (isMouseOver !== null) {
			updateIsAnimStarted(false);
			setTimeout(() => {
				startAnim(true);
			}, 100)
		}
	}, [isMouseOver])

	return (
		<div
			className={`GlitchingChars ${isAnimStarted ? 'is-anim-started' : ''}`}
			ref={containerEl}
		>
			<span className="GlitchingChars__Hidden">
				{children}
			</span>
			<span
				className="GlitchingChars__Text"
				ref={charsContainerEl}
			>
				<SplitText splitBy="chars">
					{children}
				</SplitText>
			</span>
		</div>
	);
}

export default GlitchingChars;